/* Copyright (C) NewFoundry 2021 All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var constants_1 = require("../constants");

var initialState = {
  countryCode: 'US'
};

var appReducer = function appReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  var assign = function assign(update) {
    return Object.assign({}, state, update);
  };

  switch (action.type) {
    case constants_1.APP.SAVE_ENV:
      {
        var env = action.env;
        return Object.assign({}, state, {
          env: env
        });
      }

    default:
      return state;
  }
};

exports.default = appReducer;